import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

interface ContentSectionProps {
  children?: any;
  title?: any;
  withBorder?: any;
  }
const ContentSection = ({ children, title, withBorder }: ContentSectionProps) =>
    title ? (
        <details
            open
            className={cn(styles.section, {
                [styles["section--with-border"]]: withBorder,
            })}
        >
            <summary className={styles.section__title}>{title}</summary>
            <ul className={styles.section__list}>{children}</ul>
        </details>
    ) : (
        <ul
            className={cn(styles.section__list, styles["section__list--with-margin"], {
                [styles["section__list--with-border"]]: withBorder,
            })}
        >
            {children}
        </ul>
    );

export default ContentSection;
